const props = {
  /**
   * The svg icon node
   */
  icon: {
    type: String,
  },
  /**
   * The html element used for the button.
   * `button, a`
   */
  type: {
    type: String,
    default: 'button',
    validator: (value) => {
      return value.match(/(button|a)/);
    },
  },
  /**
   * The size of the button. Defaults to medium.
   * `extra-small, small, medium, large`
   */
  size: {
    type: String,
    default: 'medium',
    validator: (value) => {
      return value.match(/(extra-small|small|medium|large)/);
    },
  },
  /**
   * Manually trigger various states of the button.
   * `hover, active, focus`
   * **This Prop should be used sparingly, the css should handle this in almost all cases**
   */
  state: {
    type: String,
    default: null,
    validator: (value) => {
      return value.match(/(hover|active|focus)/);
    },
  },
  /**
   * Style variation to give additional meaning.
   * `primary, secondary, tertiary, warning, minimal, caution`
   */
  variation: {
    type: String,
    default: 'primary',
    validator: (value) => value.match(/(primary|secondary|tertiary|warning|minimal|caution|link|iconOnly)/),
  },
};

export default props;
